import { post, get, phpPost } from "../util/crmAxios";
//查询通话记录
export const queryCallRecords = (params) => post('/crm/callRecord/queryCallRecords', params);
//查询通时通次
export const queryStaticData = (params) => post('/crm/callRecord/queryStaticData', params);
//查询天润录音接口
export const describeRecordFileUrl = (params) => get('/crm/callCenter/describeRecordFileUrl', params);
//查询呼叫人
// export const getSubUsers = (params) => post('/crm/user/getSubUsers', params);
export const getSubUsers = (params) => {
    return new Promise(async (resolve, reject) => {
        const keyName = `CRM_SUBUSERS`
        let DictionarysList = JSON.parse(sessionStorage.getItem(keyName) || '[]');
        if ( DictionarysList.length <= 0 ) {
            DictionarysList = await post('/crm/user/getSubUsers', params)
            DictionarysList = DictionarysList.code === 0 ? DictionarysList.data : []
            sessionStorage.setItem(keyName, JSON.stringify(DictionarysList))
            resolve({
                code: 0,
                data: DictionarysList
            })
        } else {
            resolve({
                code: 0,
                data: DictionarysList
            })
        }
    })
};

// 校长端消息系统签名
export const getMessageSocketConfig = (params) => get('/erp/notice/getMessageSocketConfig', params);
// 获取公告列表
export const messageList = (params) => phpPost('/sdk/java/messageList', params);

// 批量停课
export const stopBatchSubject = (params) => phpPost('/os/stopBatchSubject', params);

// 运营系统消息系统签名
export const socket_auth = (params) => get('/crm/msg/socket_auth', params)

// 呼叫中心-签入签出置忙置闲
export const userSign = params => post('/crm/callCenter/userSign', params)

// 呼叫中心-获取分机状态
export const getExtStatus = params => post('/crm/callCenter/getExtStatus', params)

// 呼叫中心-拨打电话
export const dial = params => post('/crm/callCenter/dial', params)

// 呼叫中心-外呼取消(天润)
export const callOutCancel = params => post('/crm/callCenter/callOutCancel', params)

// 呼叫中心-通时通次
export const getUserCallInfo = params => post('/crm/callRecord/getUserCallInfo', params)
//呼叫中心-坐席监听
export const getAgentMonitorInfo = params => post('/crm/monitor/getAgentMonitorInfo', params)

//清空话务权限
export const deleteUserCallCenter = params => get('/crm/account/deleteUserCallCenter', params)
//获取校区用户
export const getUsersBySchoolId = params => get('/crm/user/getUsersBySchoolId', params)
//易迅 获取token
export const YiXunGetToken = params => get('/crm/callCenter/getToken', params)

//清空话务权限
export const queryCustomerInfoByPhone = params => {
    let newParams = '?'
    Object.keys(params).forEach(item => {
        newParams += `${item}=${params[item]}&`
    })
    return post(`/crm/search/queryCustomerInfoByPhone${newParams}` )
}

// 呼叫中心-挂断

export const hangUp = params => {
    if (params.callCenterType - 3 === 0) { // 天润
        return  post('/crm/callCenter/unlink', params)
    } else if (params.callCenterType - 4 === 0) { // 汉天
        return  post('/crm/callCenter/hangUp', params)
    }
}

export const spy = params => {
    let newParams = '?'
    Object.keys(params).forEach(item => {
        newParams += `${item}=${params[item]}&`
    })
    return post(`/crm/callCenter/spy${newParams}`)
}
